import React from 'react';
import BackgroundImage from '../assests/top_section_bg.jpg';

const Hero = () => {
  return (
    <section
      id='home'
      className='relative flex items-center justify-center overflow-hidden'
      style={{ minHeight: '872px', padding: '141px 20px' }}
    >
      {/* Background image */}
      <div
        className='absolute inset-0'
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      ></div>

      {/* Main content */}
      <div className='relative z-10 w-full max-w-[1029px] mx-auto px-4'>
        {/* Hero Panel */}
        <div className='backdrop-blur-[2px] bg-[rgba(255,255,255,0.1)] border border-white rounded-[70px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] px-6 sm:px-[41px] py-8 sm:py-[54px] flex flex-col items-center gap-6 sm:gap-[34px]'>
          <div className='w-full flex items-center justify-center'>
            <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[64px] font-bold text-white text-center leading-[normal]'>
              Transform your business with Quantum Soft
            </h1>
          </div>
          {/* Button */}
          <button className='backdrop-blur-[2px] bg-[rgba(255,255,255,0.1)] border border-white rounded-[65px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] px-8 sm:px-[94px] py-4 sm:py-[30px] text-lg sm:text-xl lg:text-2xl xl:text-[32px] font-normal text-white hover:opacity-90 transition-opacity'>
            Get Started
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
